import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecurity = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M24 6L8 13v12c0 9 7 16.5 16 19 9-2.5 16-10 16-19V13L24 6Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17 24l5 5 9-9",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSecurity;
